var map = {
	"./black/jianting.png": "Sh5a",
	"./blue/jianting.png": "UlQY",
	"./white/jianting.png": "Xnu9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cV6+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/jianting\.png$
// module id = cV6+
// module chunks = 24